var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMustard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 19,
    viewBox: "0 0 9 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08203 0.100388L5.10742 0.160934L6.4668 3.40019H7.81348C8.30208 3.40019 8.7 3.79737 8.7002 4.28593V17.2605C8.7002 17.8338 8.23435 18.2995 7.66113 18.2996H1.13965C0.56632 18.2996 0.100586 17.8339 0.100586 17.2605V4.28593C0.100783 3.79743 0.497797 3.40028 0.986328 3.40019H2.33398L3.69336 0.160934L3.71875 0.100388H5.08203ZM0.900391 17.2605C0.900391 17.3925 1.00768 17.4998 1.13965 17.4998H7.66113C7.793 17.4997 7.90039 17.3924 7.90039 17.2605V5.9998H0.900391V17.2605ZM7.2002 5.2H7.90039V4.28593C7.9002 4.23843 7.86103 4.2 7.81348 4.2H7.2002V5.2ZM5.40039 5.2H6.40039V4.2H5.40039V5.2ZM3.90039 5.2H4.60059V4.2H3.90039V5.2ZM2.40039 5.2H3.10059V4.2H2.40039V5.2ZM0.986328 4.2C0.938855 4.20009 0.900586 4.23849 0.900391 4.28593V5.2H1.60059V4.2H0.986328ZM3.20215 3.40019H5.59766L4.54883 0.900192H4.25098L3.20215 3.40019Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89502 11.5293L7.96631 11.5996L4.3999 15.166L4.32959 15.0947L0.834473 11.5996L0.905762 11.5293L4.32959 8.10548L4.3999 8.03419L7.89502 11.5293ZM1.96533 11.5996L4.3999 14.0342L6.83447 11.5996L4.3999 9.16505L1.96533 11.5996Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustard);
export default __webpack_public_path__ + "static/media/mustard.42b275befa2382cd9fd56b8a462acb57.svg";
export { ForwardRef as ReactComponent };